import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Sparkles } from "lucide-react";
import Nav from "@/components/Nav";
import FloatingShapes from "@/components/FloatingShapes";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { checkAuth } = useAuth();
  const sid = params.get("session_id") || params.get("token");
  const [status, setStatus] = useState("polling");
  const [plan, setPlan] = useState(null);

  useEffect(() => {
    if (!sid) { nav("/pricing"); return; }
    let attempts = 0;
    const poll = async () => {
      try {
        const r = await api.get(`/checkout/paypal/status/${sid}`);
        setPlan(r.data.plan);
        if (r.data.payment_status === "paid") {
          setStatus("paid");
          await checkAuth();
          toast.success("Payment successful! ✨");
          setTimeout(() => nav("/dashboard"), 1800);
          return;
        }
        if (r.data.status === "expired") { setStatus("expired"); return; }
      } catch {}
      if (++attempts < 8) setTimeout(poll, 2000);
      else setStatus("timeout");
    };
    poll();
  }, [sid, nav, checkAuth]);

  const msg = {
    polling: "Confirming your payment…",
    paid:    "You're in. Opening your decks…",
    expired: "That session expired. Try again from /pricing.",
    timeout: "Taking longer than usual. Refresh in a moment.",
  }[status];

  return (
    <div className="relative min-h-screen grain" data-testid="billing-success-page">
      <FloatingShapes /><Nav />
      <main className="relative z-10 max-w-xl mx-auto px-6 pt-40 text-center">
        {status === "paid"
          ? <Sparkles className="w-12 h-12 text-indigo-500 mx-auto" data-testid="billing-success-icon"/>
          : <Loader2 className="w-12 h-12 animate-spin text-indigo-500 mx-auto" data-testid="billing-loading"/>}
        <h1 className="font-display text-4xl mt-6">{msg}</h1>
        {plan && <p className="font-hand text-stone-500 text-2xl mt-2">{plan.replace("_"," ")}</p>}
      </main>
    </div>
  );
}
